import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import { handleOnChangeIsEdit } from '../../utils/widget'
import ScrutinizeMethodWidget from '../../widgets/scrutinizeMethod/ScrutinizeMethodWidget'
import { getScrutinizeSchemaMulti } from '../../redux/actions/scrutinize'
import { isNewMultiReveiw } from '../../utils/ValidatorUtils'

export default function ScrutinizeMethodSingle() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [requestBody, setRequestBody] = useState()
  const [projectList, setProjectList] = useState()
  const [projectIdList, setProjectIdList] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let request = { id: projectId }
      const response = await getScrutinizeSchemaMulti(request)

      setSchema(response)
      setIsEditWidget({
        scrutinizeMethod: isNewMultiReveiw(projectId),
      })
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      {schema?.forms?.scrutinizeMethod && (
        <>
          <ScrutinizeMethodWidget
            showCommandButton={!schema.forms.scrutinizeMethod.disabled}
            schema={schema.forms.scrutinizeMethod}
            isEdit={isEditWidget.scrutinizeMethod}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('scrutinizeMethod', _isEdit, setIsEditWidget)
            }
            projectIdList={projectIdList}
            isSingle={true}
          />
          <br />
        </>
      )}
    </SidebarProposal>
  )
}

// const mockSchema = {
//   header: 'บันทึกวิธีการกลั่นกรอง (หลายโครงการ)',
//   subHeader: '',
//   forms: {
//     scrutinizeMethod: {
//       header: 'วิธีการกลั่นกรองทางวิชาการ',
//       buttonText: 'บันทึกวิธีการกลั่นกรองทางวิชาการ',
//       scrutinizeMethod: {
//         name: 'scrutinizeMethod',
//         value: '1',
//         options: [
//           {
//             label: 'โดยการประชุม',
//             value: '1',
//           },
//           {
//             label: 'โดยผู้ทรงคุณวุฒิ',
//             value: '2',
//           },
//         ],
//       },
//       meettingName: {
//         name: 'meettingName',
//         label: 'ชื่อการประชุม',
//         value: 'ttttt',
//         validators: [
//           {
//             type: 'REQUIRED',
//             errorMessage: 'กรุณากรอกชื่อการประชุม',
//           },
//         ],
//       },
//       meettingDate: {
//         name: 'meettingDate',
//         label: 'วันที่ประชุม',
//         value: '',
//         validators: [
//           {
//             type: 'REQUIRED',
//             errorMessage: 'กรุณาระบุวันที่ประชุม',
//           },
//         ],
//       },
//       attachFiles: {
//         name: 'attachFiles',
//         label: 'แนบไฟล์อื่น ๆ ที่เกี่ยวข้องกับการประชุม',
//         values: [
//           {
//             id: 'DD71CE7A-D88B-4835-B266-2BA29EB56089',
//             deleteId: 'DD71CE7A-D88B-4835-B266-2BA29EB56089,FA6C3D56-08C0-432E-8474-03D34527CE1E',
//             fileName: 'google_white5_hdpi.png',
//             fileLabel: 'google_white5_hdpi.png',
//             filePath: 'reviwer/meeting/7DC3654A-70C3-463E-9C5C-87B2283B3982.png',
//           },
//         ],
//         id: 'DD71CE7A-D88B-4835-B266-2BA29EB56089,FA6C3D56-08C0-432E-8474-03D34527CE1E',
//       },
//     },
//   },
// }
